import styled, { css } from 'styled-components';
import { COLORS, FONTS } from './../../ui';

interface Props {
  active?: boolean;
  disabled?: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  user-select: none;
`;

export const ActionPage = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 26px;
  height: 26px;
  cursor: pointer;
  margin: 0 4px;
  border-radius: 4px;

  ${(props: Props) => props.disabled && css`
    pointer-events: none;

    div svg {
      color: ${COLORS.LIGHT_GRAY};
    }
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Page = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 26px;
  height: 26px;
  font-family: ${FONTS.ROBOTO_REGULAR};
  font-size: 14px;
  background: ${COLORS.LIGHT_GRAY};
  color: ${COLORS.BLACK};
  box-sizing: border-box;
  border: 1px solid ${COLORS.OPAQUE_GRAY};
  border-radius: 4px;
  cursor: pointer;
  margin: 0 8px;

  &:hover {
    background: ${COLORS.OPAQUE_GRAY};
  }

  ${(props: Props) => props.active && `
    background: ${COLORS.BLACK};
    color: ${COLORS.WHITE};
    border: 1px solid ${COLORS.BLACK};

    &:hover {
      border: 1px solid ${COLORS.HOVER_BLACK};
      background: ${COLORS.HOVER_BLACK};
    }
  `};
`;
